import { Box, Collapse, Grid, ListItemButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme from "../../../../theme";

export const SearchBarContainer = styled(Box)(
  ({ width }: { width?: string }) => ({
    width: width || "800px",
    flexShrink: 0,
  }),
);

export const CollapseMenu = styled(Collapse)({
  width: "inherit",
  position: "absolute",
  backgroundColor: "#FFFFFF",
  borderTop: `1px solid ${theme.palette.primary.light}`,
  borderRadius: "4px",
  marginTop: "-20px",
  zIndex: "100",
  boxShadow: "0px 4px 6px #1018281A",
});

export const CollapseMenuContent = styled(Box)({
  margin: "10px",
});

export const SearchTermItem = styled(ListItemButton)({
  padding: "2.5px 0px",
  cursor: "pointer",
  fontSize: "16px",
});

export const FilterChipContainer = styled(Box)({
  minHeight: "30px",
  height: "auto",
  marginBottom: "20px",
});

export const CenteredGridItem = styled(Grid)({
  marginBottom: "10px",
  alignItems: "center",
});

export const GridItemsContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});
